"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferAssetGalleryFieldActionButtons = OfferAssetGalleryFieldActionButtons;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const elements_1 = require("@src/components/elements");
const icons_1 = require("@ant-design/icons");
const react_intl_1 = require("react-intl");
const ActionButtonsContainer = styled_components_1.default.div `
	display: flex;
	flex-wrap: wrap;
	width: 100%;
	gap: 2rem;
	justify-content: center;
`;
function OfferAssetGalleryFieldActionButtons({ openOfferAssetLibrarySelectionModal, removeThisGallery }) {
    return ((0, jsx_runtime_1.jsxs)(ActionButtonsContainer, { children: [(0, jsx_runtime_1.jsxs)(elements_1.Button, { type: "primary", size: "middle", icon: (0, jsx_runtime_1.jsx)(icons_1.EditOutlined, {}), onClick: openOfferAssetLibrarySelectionModal, children: ["\u00A0", (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.offer.assets.gallery_form.select_assets" })] }), (0, jsx_runtime_1.jsxs)(elements_1.Button, { type: "primary", danger: true, size: "middle", onClick: removeThisGallery, icon: (0, jsx_runtime_1.jsx)(icons_1.DeleteOutlined, {}), children: ["\u00A0", (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.offer.assets.gallery_form.delete_gallery" })] })] }));
}
